import { useState, useEffect, useRef } from 'react'
import { UUID } from "uuidjs";
import useClient from './useClient'
import cloneDeep from 'lodash.clonedeep'

export default function useLocation(_locationUUID = null) {
  const [location, setLocation] = useState({})
  const [openState, setOpenState] = useState({})
  const [extendedPrepTime, setExtendedPrepTimeState] = useState(null)
  const [cloudDevice, setCloudDevice] = useState({})
  const [paymentAgents, setPaymentAgents] = useState([])

  const { client, selectedLocationUUID, locations } = useClient()

  const uid = useRef(UUID.generate())

  useEffect(() => {
    let currentLocation = client?.locationsModel.getLocation(location?.uuid) || {}
    //console.log('SET OPEN STATE:', currentLocation?.openState, currentLocation?.uuid)
    setOpenState(currentLocation?.openState || {})
    setPaymentAgents(currentLocation?.paymentAgents || [])
    setExtendedPrepTimeState({ ...(currentLocation?.extendedPrepTime || {}) })
    setCloudDevice({ ...(currentLocation?.cloudDevice || {}) })
  }, [location])

  const onLocationUpdated = (info) => {
    if (info.location.uuid === selectedLocationUUID) {
      setLocation(cloneDeep(info.location))
    }
  }

  useEffect(() => {
    setLocation(cloneDeep(locations?.[(_locationUUID != null ? _locationUUID : selectedLocationUUID)]) || {})
  }, [locations, selectedLocationUUID, _locationUUID])

  useEffect(() => {
    if (client != null) {
      client.locationsModel.addCallback('onLocationOpenStateUpdated', uid.current, onLocationUpdated)
      client.locationsModel.addCallback('onLocationExtendedPrepTimeUpdated', uid.current, onLocationUpdated)
      client.locationsModel.addCallback('onLocationCloudDeviceUpdated', uid.current, onLocationUpdated)
    }

    return () => {
      // ON UNMOUNT
      if (client != null) {
        client.locationsModel.removeCallback('onLocationOpenStateUpdated', uid.current)
        client.locationsModel.removeCallback('onLocationExtendedPrepTimeUpdated', uid.current)
        client.locationsModel.removeCallback('onLocationCloudDeviceUpdated', uid.current)
      }
    }
  }, [client])

  const getPreOrderOpenHoursDates = async (dates) => {
    let res = await client.locationsModel.getOpenHoursDates(location.uuid, 'app_preorder', dates)
    return res
  }

  const getLocationOpenHoursDates = async (dates) => {
    let res = await client.locationsModel.getOpenHoursDates(location.uuid, 'location', dates)
    return res
  }

  return {
    location,
    openState,
    paymentAgents,
    extendedPrepTime,
    cloudDevice,
    getPreOrderOpenHoursDates,
    getLocationOpenHoursDates
  }
}
